<template>
  <v-menu
    min-width="550px"
    max-width="550px"
    v-model="opened"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn :small="small" icon v-on="{...on, ...onTooltip}">
            <v-icon :small="small" :color="iconColor">mdi-text-box-plus-outline</v-icon>
          </v-btn>
        </template>
        <span>Cadastros adicionais do produto</span>
      </v-tooltip>
    </template>
    <v-card class="mx-auto">
      <v-card-text class="text--primary">
        <v-row dense>
          <v-col cols="12">
            <px-autocomplete-centro-custo
              :dense="dense"
              :class="`rounded-tag-small ${isCentroCustoRequired ? 'required' : ''}`"
              :error="$v.produto.centroCusto.$error"
              @blur="$v.produto.centroCusto.$touch()"
              v-model="produto.centroCusto"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <px-autocomplete-projeto
              :dense="dense"
              class="rounded-tag-small"
              v-model="produto.projeto"/>
          </v-col>
        </v-row>
        <v-row dense v-if="showNotaEntrada">
          <v-col cols="12">
            <px-autocomplete-nota-entrada
              dense
              :class="`rounded-tag-small ${isTipoNotaEntradaRequired ? 'required' : ''}`"
              :error="$v.produto.tipoNotaEntrada.$error"
              @blur="$v.produto.tipoNotaEntrada.$touch()"
              v-model="produto.tipoNotaEntrada"/>
          </v-col>
        </v-row>
        <template v-if="showCadastrosAdicionais">
          <px-campos-integracao :dense="dense"
                                :form-data="cadastrosAdicionais"
                                :type="cadastrosAdicionaisType"/>
        </template>
        <v-row dense>
          <v-col cols="12">
            <v-btn @click="onClickConcluir" color="primary"
                   class="rounded-tag-small normal-btn-text elevation-0">
              Concluir
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';
import {
  isFieldRequiredEntityItens,
} from '@/modules/erp-campos-obrigatorios/erp-campos-obrigatorios-utils';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    produto: {
      type: Object,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    showCadastrosAdicionais: {
      type: Boolean,
      default: false,
    },
    showNotaEntrada: {
      type: Boolean,
      default: false,
    },
    cadastrosAdicionais: {
      type: Object,
    },
    cadastrosAdicionaisType: {
      type: String,
      default: 'compra-item',
    },
    camposObrigatorios: Object,
  },
  data() {
    return {
      opened: false,
    };
  },
  computed: {
    iconColor() {
      if (this.$v.$invalid && this.$v.$dirty) {
        return 'error';
      }
      if (this.produto.centroCusto || this.produto.projeto) {
        return 'primary';
      }
      return '';
    },
    isCentroCustoRequired() {
      return isFieldRequiredEntityItens('centroCusto', this.camposObrigatorios);
    },
    isTipoNotaEntradaRequired() {
      return isFieldRequiredEntityItens('tipoNotaEntrada', this.camposObrigatorios);
    },
  },
  methods: {
    onClickConcluir() {
      this.opened = false;
    },
    validate() {
      return this.validateForm();
    },
  },
  validations: {
    produto: {
      centroCusto: {
        required: requiredIf(function () {
          return this.isCentroCustoRequired;
        }),
      },
      tipoNotaEntrada: {
        required: requiredIf(function () {
          return this.isTipoNotaEntradaRequired;
        }),
      },
    },
  },
};
</script>
